import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddFirmware = () => {
  const navigate = useNavigate();
  const { id, name } = useParams();
  const { getUrlByOperation } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    FirmwareName: "",
    FirmwareVersion: "",
    Remark: "",
    Active: true,
    File: null
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    // Create FormData object for multipart/form-data
    const formDataToSend = new FormData();
    formDataToSend.append("FirmwareName", formData.FirmwareName);
    formDataToSend.append("FirmwareVersion", formData.FirmwareVersion);
    formDataToSend.append("Remark", formData.Remark);
    formDataToSend.append("Active", formData.Active);
    if (formData.File) {
      formDataToSend.append("File", formData.File);
    }

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/FirmwareOperation/SubUser/Insert',
        formDataToSend,
        {
          headers: {
            "accept": "text/plain",
            "X-Authorization": token,
            "UserId": userid,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Check if the API response indicates failure
      if (response.data && (response.data.isresponse === false || response.data.responsestatus === "FAIL")) {
        // Display the error message from the API
        setMessage(response.data.errormsg || "Failed to add Firmware.");
        return;
      }

      setMessage("Firmware added successfully!");

      // Navigate to another page after 3 seconds
      setTimeout(() => {
        navigate("/Firmware");
      }, 3000);
    } catch (error) {
      console.error("Error adding firmware:", error);
      setMessage("Failed to add Firmware.");
    }
  };

  // Handle input change for text inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle file input change
  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      File: e.target.files[0] // Store the first selected file
    }));
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Firmware</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Firmware Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.FirmwareName}
                                onChange={handleChange}
                                placeholder="Enter firmware name"
                                name="FirmwareName"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Firmware Version</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.FirmwareVersion}
                                onChange={handleChange}
                                placeholder="Enter version"
                                name="FirmwareVersion"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.Remark}
                                onChange={handleChange}
                                placeholder="Enter remark"
                                name="Remark"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select 
                                className="form-control" 
                                name="Active" 
                                value={formData.Active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Firmware File</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleFileChange}
                                accept=".zip,application/zip,application/x-zip-compressed"
                                required
                              />
                              <small className="text-muted">Upload a zip file</small>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Firmware added successfully!" && (
        <SuccessMessage message={message} />
      )}

      {message && message !== "Firmware added successfully!" && (
        <FailedMessage message={message} />
      )}
    </>
  );
};

export default AddFirmware;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
